$(window).on("load", function(){
  
  // Load images in collections product grid image container on swatch hover
  setTimeout(function(){
    $(".grid-product .pl-swatches-collection .pl-swatches-collection__swatch-wrapper").on("mouseenter", function(){
      let firstImage = $(this).closest(".grid__item-image-wrapper").find(".grid__image-ratio");
      let secondaryImage = $(this).closest(".grid__item-image-wrapper").find(".grid-product__secondary-image");
      let swatchImage = $(this).find("img").attr("src").replace("_40x40@3x", "");

      if(secondaryImage.length > 0 ){
        secondaryImage.find("img").attr("srcset", swatchImage);
      } else {
        firstImage.find("img").attr("srcset", swatchImage);
      }

    });
    $(".grid-product .pl-swatches-collection .pl-swatches-collection__swatch-wrapper").on("mouseleave", function(){
      let firstImage = $(this).closest(".grid__item-image-wrapper").find(".grid__image-ratio");
      let secondaryImage = $(this).closest(".grid__item-image-wrapper").find(".grid-product__secondary-image");
      let firstImageSrc = firstImage.find("img").attr("src");
      let secondaryImageSrc = secondaryImage.find("img").attr("src");
      if(secondaryImage.length > 0 ){
        secondaryImage.find("img").attr("srcset", secondaryImageSrc);
      } else {
        firstImage.find("img").attr("srcset", firstImageSrc);
      }
    });
  }, 2000);

  //$('.page-starforged .feature-row-wrapper').attr("data-aos", "zoom-in");
  /* Image text group */
    $( "#shopify-section-template--15005489660007__1f7178f8-565f-47f4-99cf-5926fc2d4925, #shopify-section-template--15005489660007__882fad16-7547-4b71-b229-7c12113c73f2, #shopify-section-template--15005489660007__f14ae593-196f-4b5d-a8dd-ba9bf4787626, #shopify-section-template--15005489660007__99629106-dfd3-4a0c-927f-8cc63014f417" ).wrapAll( "<div class='sf-bg-2 parallax' />");
  /* Typewriter group 
    $(".index-section--sf-typewriter, #shopify-section-template--16073735078080__8c6815c1-db52-4711-98f9-7bc86ce3caf7").wrapAll( "<div class='sf-bg-gradient' />");
  */
  
  let sfLogo = $('.page-starforged .image__secondary');
  $(window).on("scroll", function(){
    var distance = $('div').offset().top,
    $window = $(window);

        if ( $window.scrollTop() >= distance ) {
            // Your div has reached the top
        }

    let movement = 50 - (window.scrollY / 25);
    sfLogo.css("top", movement + "%");
    sfLogo.css("opacity", 1 - (window.scrollY / 200) );
  });

  //New to DF wrap
  $( "#shopify-section-template--15005488873575__4e514938-5639-472d-be2b-67ee40dff7fe, #shopify-section-template--15005488873575__db22ef76-1b0d-45f3-be6d-a79a53a6e650, #shopify-section-template--15005488873575__6dcdc856-a78c-4102-aa52-30eae8c6addc, #shopify-section-template--15005488873575__7558e1f5-bd1f-4e7e-a906-6fc3804201c6, #shopify-section-template--15005488873575__e3b7011a-f04e-4fd1-81f2-6d3b5c43de53, #shopify-section-template--15005488873575__19a2ef23-d01b-40ee-83ce-6535e5e53f98" ).wrapAll( "<div class='ntdf-terrain' />");
  setTimeout(function(){
    $('.ntdf-terrain').slick({
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
    });
  }, 2000);
});

window.addEventListener("hashchange", function () {
    window.scrollTo(window.scrollX, window.scrollY - 100);
});

/* Load more functionality for collection grid */
var products_on_page = $('.products-on-page');
var next_url = $('.pagination .next a').attr('href');

var loadMoreBtn = $('.load-more-products');
var loadMoreSpinner = $('.load-more-spinner');

function loadMoreProducts(){
  $.ajax({
    url: next_url,
    type: "GET",
    dataType: "html",
    beforeSend: function(){
      loadMoreBtn.hide();
      loadMoreSpinner.show();
    }
  }).done(function(next_page){
    console.log(next_url);
      loadMoreSpinner.hide();
    var new_products = $(next_page).find('.products-on-page');
    var new_url = $(next_page).find('.pagination .next a').attr('href');

    if(new_url){
      loadMoreBtn.show();
    }
    next_url = new_url;
    products_on_page.append(new_products.html());
    $('.image-element').css('opacity', '1');
  });
}

$(document).ready(function(){
    if(next_url == undefined){
    loadMoreBtn.hide();
    $('.browse-by-page').hide();
  }
});

setInterval(function(){
    $('.tmenu_item_level_1').on("click", function(){
        $('.tmenu_item_level_1').attr('id', '');
        $(this).attr('id', 'tmenu_new_active');
      });
}, 500);

$(window).on('load', function(){
  if(localStorage.getItem("Open Cart") == "true"){
    $('a[aria-controls="CartDrawer"]')[0].click();
    localStorage.setItem("Open Cart", false);
  }

  if($(window).width() < 769){
    setTimeout(function(){
      $('.collection-filter__item.collection-filter__item--sort').appendTo('.grid__item.medium-up--one-fifth.grid__item--sidebar');
    }, 500);
  }
});

  $('.ajax-to-cart-wrapper form').on('submit', function(event) {
    event.preventDefault(); // prevent default form submission
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: $(this).serialize(),
      dataType: 'json',
      success: function() {
        $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        //refreshCart();
        localStorage.setItem("Open Cart", "true");
        location.reload();
        //$('a[aria-controls="CartDrawer"]')[0].click();
        //$('html').addClass('js-drawer-open');
        //$('#CartDrawer').addClass('drawer--is-open');
      },
      error: function(data) {
        if(data.message == undefined){
          alert("Not enough available");
        }
      }
    });
  });

/* Not currently working 
  function refreshCart(){
    $.ajax({
      url: window.location.href,
      type: "GET",
      dataType: "html",
      beforeSend: function(){
      }
    }).done(function(next_page){
      var new_cart = $(next_page).find('#CartDrawer');
      $('#CartDrawer').replaceWith(new_cart);
    });
  } */

/* Light/Dark Mode */
$(document).ready(function(){

  if (localStorage.getItem('lightMode') == null){
    localStorage.setItem('lightMode', false);
  }

  if (localStorage.getItem('lightMode') == "true") {
    $('.light-dark-mode').addClass('dark-mode');
    $('.light-dark-mode .switch').text('Dark Mode');
    $('body, .shopify-section, .shopify-section .page-width').addClass('light-mode');
    $('body').append('<link rel="stylesheet" type="text/css" href="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css">');
  } else {
    $('link[rel=stylesheet][href*="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css"]').remove();
  }
  
  $('.light-dark-mode').on('click', function(){
    $('body, .shopify-section, .shopify-section .page-width').toggleClass('light-mode');
    localStorage.setItem('lightMode', $('body').hasClass('light-mode'));

    if (localStorage.getItem('lightMode') == "true") {
      $('.light-dark-mode').addClass('dark-mode');
      $('.light-dark-mode .switch').text('Dark Mode');
      $('body').append('<link rel="stylesheet" type="text/css" href="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css">')
    } else {
      $('.light-dark-mode').removeClass('dark-mode');
      $('.light-dark-mode .switch').text('Light Mode');
      $('link[rel=stylesheet][href*="https://cdn.shopify.com/s/files/1/0644/2359/files/light-mode.css"]').remove();
    }
      
  });

});